export class NotAuthorizedError extends Error {
  static code = 'NotAuthorizedException';

  constructor() {
    super();
    this.message = 'Error.NotAuthorizedException';
  }
}
